import {combineReducers, Dispatch, Action, AnyAction} from 'redux'
import {reducer as toastrReducer, ToastrState} from 'react-redux-toastr'
import {GlobalReducer, GlobalState} from "./global";
import {CoreReducer, CoreState} from "../core/store";
import {TabsReducer, TabsState} from "./tabs";
import {CustomersReducer, CustomersState} from "./customers";
import {ServicesState, ServicesReducer} from './services';
import {UsersReducer, UsersState} from "./users";
import {RolesReducer, RolesState} from "./roles";
import {CategoriesState, CategoriesReducer} from './categories';
import {ContractsReducer, ContractsState} from "./contracts";
import {PaymentsReducer, PaymentsState} from './payments';
import {InvoicesReducer, InvoicesState} from "./invoices";
import {ReducerState} from "react";
import {ReportsReducer, ReportsState} from "./reports";
import {TenantReducer, TenantState} from "./tenant";
import {CustomerFinances} from "../models/CustomerFinances";
import {CustomerFinancesTabState} from "../tabs/customers/CustomerFinancesTab";
import {DocumentsReducer, DocumentsState} from "./documents";
import {FoldersReducer, FoldersState} from "./folders";
import {DepartmentsState, DepartmentsReducer } from './departments';
import {PositionsState, PositionsReducer } from './positions';
import {EmployeesState, EmployeesReducer } from './employees';
import {NotificationsState, NotificationsReducer } from './notifications';

// The top-level state object
export interface ApplicationState {
	core: CoreState,
	global: GlobalState,
	tabs: TabsState,
	customers: CustomersState,
	services: ServicesState,
	categories: CategoriesState,
	users: UsersState,
	roles: RolesState,
	contracts: ContractsState,
	payments: PaymentsState,
	invoices: InvoicesState,
	toastr: ToastrState,
	reports: ReportsState,
	tenant: TenantState,
	documents: DocumentsState,
	folders: FoldersState,
	departments: DepartmentsState,
	positions: PositionsState,
	employees: EmployeesState,
	notifications: NotificationsState
}

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
	dispatch: Dispatch<A>
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const AppRootReducer = combineReducers<ApplicationState>({
	core: CoreReducer,
	global: GlobalReducer,
	tabs: TabsReducer,
	customers: CustomersReducer,
	services: ServicesReducer,
	categories: CategoriesReducer,
	users: UsersReducer,
	roles: RolesReducer,
	contracts: ContractsReducer,
	payments: PaymentsReducer,
	invoices: InvoicesReducer,
	toastr: toastrReducer, // <- Mounted at toastr.
	reports: ReportsReducer,
	tenant: TenantReducer,
	documents: DocumentsReducer,
	folders: FoldersReducer,
	departments: DepartmentsReducer,
	positions: PositionsReducer,
	employees: EmployeesReducer,
	notifications: NotificationsReducer
});

export const AppReducer = (state: any, action: any) => {
	if (action.type === 'RESET_APP') {
		state = undefined;
	}
	return AppRootReducer(state, action);
}

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*

// export function* rootSaga() {
// 	yield all([fork(heroesSaga), fork(teamsSaga)])
// }
